import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import neighborhoodReadAction from './neighborhoodRead.action.json' assert { type: 'json' }

const neighborhoodReadDefinition = defineReadAutoAction(neighborhoodReadAction, 'neighborhood')

export default neighborhoodReadDefinition
